import { render, staticRenderFns } from "./DialogMoverElemento.vue?vue&type=template&id=6fb91a90"
import script from "./DialogMoverElemento.vue?vue&type=script&lang=js"
export * from "./DialogMoverElemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports